import { http } from "@/providers/http";
import { utils } from "@/utils/utils";

export class EndorsementFormApi {
  private static INSTANCE = new EndorsementFormApi();

  static get instance() {
    return this.INSTANCE;
  }

  public submitEndorsementApplication(fillStatus: string, payLoadData: any) {
    const userDetails = utils.getUserDetails();
    let adminuserDetail: any = localStorage.getItem("admin_user_details");
    if (adminuserDetail) {
      adminuserDetail = JSON.parse(adminuserDetail);
    }
    const data = {
      fillStatus: payLoadData.fillStatus,
      data: {
        endorsementBasicDetails: payLoadData.endorsementBasicDetails,
        endorsementJusticeInvolvement:
          payLoadData.endorsementJusticeInvolvement,
        endorsementSupervisor: payLoadData.endorsementSupervisor,
        endorsementSignature: payLoadData.endorsementSignature,
      },
      submittedBy:
        userDetails &&
        (!userDetails.roles || userDetails.roles === null) &&
        !localStorage.getItem("impersonateId")
          ? userDetails.userId || userDetails.user_id
          : adminuserDetail && adminuserDetail.userId
          ? adminuserDetail.userId
          : null,
    };
    const endpoint = "cprs/endorsement";
    const anonymousToken = localStorage.getItem("anonymousToken");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${anonymousToken}`,
    };
    return http.post(endpoint, headers, data).then((response) => {
      return response;
    });
  }

  public getEndorsementApplication(applicationID?: string) {
    const endpoint = `cprs/endorsement`;
    const params = { id: applicationID };
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return response;
    });
  }

  public updateEndorsementApplication(payLoadData: any, id: string) {
    const userDetails = utils.getUserDetails();
    let adminuserDetail: any = localStorage.getItem("admin_user_details");
    if (adminuserDetail) {
      adminuserDetail = JSON.parse(adminuserDetail);
    }
    const endpoint = `cprs/endorsement?id=${id}`;
    const data = {
      id: id,
      fillStatus: payLoadData.fillStatus,
      data: {
        endorsementBasicDetails: payLoadData.endorsementBasicDetails,
        endorsementJusticeInvolvement:
          payLoadData.endorsementJusticeInvolvement,
        endorsementSupervisor: payLoadData.endorsementSupervisor,
        endorsementSignature: payLoadData.endorsementSignature,
      },
      submittedBy:
        userDetails &&
        (!userDetails.roles || userDetails.roles === null) &&
        !localStorage.getItem("impersonateId")
          ? userDetails.userId || userDetails.user_id
          : adminuserDetail && adminuserDetail.userId
          ? adminuserDetail.userId
          : null,
    };
    const anonymousToken = localStorage.getItem("anonymousToken");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${anonymousToken}`,
    };
    return http.put(endpoint, headers, data).then((response) => {
      return response;
    });
  }

  public updateEndorsementApplicationByAdmin(payLoadData: any, id: string) {
    const endpoint = `cprs/endorsement/application`;
    const payload = {
      id: id,
      data: {
        endorsementBasicDetails: payLoadData.endorsementBasicDetails,
        endorsementJusticeInvolvement:
          payLoadData.endorsementJusticeInvolvement,
        endorsementSupervisor: payLoadData.endorsementSupervisor,
        endorsementSignature: payLoadData.endorsementSignature,
        History: payLoadData.History || {},
        editedComments: payLoadData.editedComments || {},
      },
    };
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, payload).then((response) => {
      return response;
    });
  }

  public updateEndorsementApplicationByApplicant(payLoadData: any, id: string) {
    const endpoint = `cprs/endorsement/applicant/edit`;
    const payload = {
      id: id,
      data: {
        endorsementBasicDetails: payLoadData.endorsementBasicDetails,
        endorsementJusticeInvolvement:
          payLoadData.endorsementJusticeInvolvement,
        endorsementSupervisor: payLoadData.endorsementSupervisor,
        endorsementSignature: payLoadData.endorsementSignature,
        History: payLoadData.History || {},
        editedComments: payLoadData.editedComments || {},
      },
    };
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, payload).then((response) => {
      return response;
    });
  }

  public approveEndorsementApplication(command: any) {
    const endpoint = `cprs/endorsement/approve`;
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, command).then((response) => {
      return response;
    });
  }

  public rubricEndorsementApplication(command: any) {
    const endpoint = `cprs/endorsement/rubric`;
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, command).then((response) => {
      return response;
    });
  }

  public getEndorsementApplicationByEmail(email: string) {
    const endpoint = `cprs/endorsement/details`;
    const params = { email };
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return response;
    });
  }

  public deleteEndorsementApplication(id: string) {
    const endpoint = `cprs/endorsement?id=${id}`;
    const headers = http.getTokenHeaders();
    return http.delete(endpoint, headers).then((response) => {
      return response;
    });
  }

  /**
   * Stores the endorsement's certificate file. No certificate number: the
   * endorsement is issued against the CPRS number the applicant gave on the
   * application, which the API reads from the application's own data rather than
   * taking a copy that could drift from it.
   */
  public endorsementCertificateUpdate(applicationId: string, file: File[]) {
    const endpoint = `cprs/endorsement/certificate`;
    const formdata = new FormData();
    formdata.append("applicationId", applicationId);
    if (file.length) {
      formdata.append("file", file[0]);
    }
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, formdata).then((response) => {
      return response.data;
    });
  }
}

export const endorsementFormApi = EndorsementFormApi.instance;
